import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["useModal", "isIcon"];
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";
import _flatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/flat";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context4, _context5; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context4 = ownKeys(Object(t), !0)).call(_context4, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context5 = ownKeys(Object(t))).call(_context5, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { Pill, IconButton, Icon, Typography, RaiseColors } from "client/componentLibrary";
import FiltersModal from "./FiltersModal";
import { isNullOrUndefined } from "utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/// Shows a bar w/ all the filters as components w/ popovers
var FiltersBarWithPills = function FiltersBarWithPills(_ref) {
  var onFiltersChange = _ref.onFiltersChange,
    filters = _ref.filters,
    filterValues = _ref.filterValues,
    className = _ref.className;
  var onCurrentFiltersChanged = function onCurrentFiltersChanged(changedFilters) {
    var nextValues = _objectSpread({}, filterValues);
    _forEachInstanceProperty(changedFilters).call(changedFilters, function (_ref2) {
      var name = _ref2.name,
        value = _ref2.value;
      if (isNullOrUndefined(value) || value === false || _Array$isArray(value) && value.length === 0) {
        delete nextValues[name];
      } else {
        nextValues[name] = value;
      }
    });

    // Calls onFilterChange function that was passed in as a prop,
    // each filter should refetch query as changes are made
    onFiltersChange(nextValues);
  };
  return /*#__PURE__*/_jsx("div", {
    "data-testid": "filters-with-pills",
    style: {
      display: "flex",
      width: "100%",
      gap: 8
    },
    className: className,
    children: _mapInstanceProperty(filters).call(filters, function (filter, index) {
      return /*#__PURE__*/_jsx(filter.Component, {
        renderAsPopover: true,
        usePill: true,
        onFiltersChange: onCurrentFiltersChanged,
        filterValues: filterValues,
        extraProps: filter.extraProps || {}
      }, index);
    })
  });
};

/// Shows a bar w/ a button that you can click to open a Filter Modal
var FiltersBarWithModal = function FiltersBarWithModal(_ref3) {
  var _context, _context2, _Object$keys$map, _context3;
  var onFiltersChange = _ref3.onFiltersChange,
    filters = _ref3.filters,
    filterValues = _ref3.filterValues,
    className = _ref3.className,
    isIcon = _ref3.isIcon,
    trackFilterOpenFn = _ref3.trackFilterOpenFn,
    getPotentialHits = _ref3.getPotentialHits;
  var _React$useState = React.useState(filterValues),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    currentFilters = _React$useState2[0],
    setCurrentFilters = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isModalOpen = _React$useState4[0],
    setIsModalOpen = _React$useState4[1];
  var _React$useState5 = React.useState(null),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    potentialResults = _React$useState6[0],
    setPotentialResults = _React$useState6[1];
  React.useEffect(function () {
    setCurrentFilters(filterValues);
  }, [filterValues]);
  React.useEffect(function () {
    if (trackFilterOpenFn && isModalOpen) {
      trackFilterOpenFn();
    }
  }, [isModalOpen, trackFilterOpenFn]);
  var onCurrentFiltersChanged = function onCurrentFiltersChanged(changedFilters) {
    var nextValues = _objectSpread({}, currentFilters);
    _forEachInstanceProperty(changedFilters).call(changedFilters, function (_ref4) {
      var name = _ref4.name,
        value = _ref4.value;
      if (isNullOrUndefined(value) || value === false || _Array$isArray(value) && value.length === 0) {
        delete nextValues[name];
      } else {
        nextValues[name] = value;
      }
    });
    getPotentialHits === null || getPotentialHits === void 0 || getPotentialHits(nextValues, function (numOfResults) {
      return setPotentialResults(numOfResults);
    });
    // Calls the setState of current filters within the context of the modal, we want to keep
    // track of which filters the user has selected/updated. A refetch should not happen
    // until the user clicks the apply button
    setCurrentFilters(nextValues);
  };

  /// Extracting the filter components here so FiltersModal doesn't have additional non-UI logic
  var filterComponents = _sortInstanceProperty(_context = _mapInstanceProperty(filters).call(filters, function (filter) {
    var _filter$isActiveCheck;
    return {
      title: filter.title,
      defaultExpanded: (_filter$isActiveCheck = filter.isActiveChecker) !== null && _filter$isActiveCheck !== void 0 && _filter$isActiveCheck.call(filter, filterValues) ? true : false,
      Component: /*#__PURE__*/_jsx(filter.Component, {
        renderAsPopover: false,
        onFiltersChange: onCurrentFiltersChanged,
        filterValues: currentFilters,
        extraProps: filter.extraProps || {}
      })
    };
  })).call(_context, function (a, b) {
    return Number(b.defaultExpanded) - Number(a.defaultExpanded);
  });
  var numAppliedFilters = _flatInstanceProperty(_context2 = (_Object$keys$map = _mapInstanceProperty(_context3 = _Object$keys(currentFilters)).call(_context3, function (key) {
    return currentFilters[key];
  })) !== null && _Object$keys$map !== void 0 ? _Object$keys$map : []).call(_context2).length;
  var onApplyFilters = function onApplyFilters() {
    onFiltersChange(currentFilters);
    setIsModalOpen(false);
  };

  // Todo Bug: Clearing all filters does not reset the form for some filters
  var onClearAllClick = function onClearAllClick() {
    setCurrentFilters({});
  };
  var toggleOpen = function toggleOpen() {
    setIsModalOpen(!isModalOpen);
  };

  /// If we closeModal w/o saving, the state should revert back to the last saved state
  var onClose = function onClose() {
    setCurrentFilters(filterValues);
    setIsModalOpen(false);
  };
  var filterColor = numAppliedFilters > 0 ? RaiseColors.destructive500 : RaiseColors.black;
  return /*#__PURE__*/_jsxs("div", {
    className: className,
    children: [isIcon ? /*#__PURE__*/_jsxs("div", {
      onClick: toggleOpen,
      "data-testid": "filters-toggle",
      children: [/*#__PURE__*/_jsx(IconButton, {
        children: /*#__PURE__*/_jsx(Icon, {
          className: "far fa-sliders-h",
          color: filterColor,
          fontSize: 14
        })
      }), /*#__PURE__*/_jsxs(Typography, {
        style: {
          marginLeft: "4px",
          cursor: "pointer"
        },
        color: filterColor,
        weight: "semibold",
        children: ["Filters (", numAppliedFilters, ")"]
      })]
    }) : /*#__PURE__*/_jsxs(Pill, {
      variant: "filter",
      leftIcon: "far fa-sliders-h",
      onClick: toggleOpen,
      isSelected: isModalOpen || numAppliedFilters > 0,
      children: ["Filters ", numAppliedFilters > 0 && "\xB7 ".concat(numAppliedFilters)]
    }), /*#__PURE__*/_jsx(FiltersModal, {
      open: isModalOpen,
      filters: filterComponents,
      numAppliedFilters: numAppliedFilters,
      onApply: onApplyFilters,
      onClearAllClick: onClearAllClick,
      onClose: onClose,
      potentialResults: potentialResults
    })]
  });
};
var FiltersBarContainer = function FiltersBarContainer(_ref5) {
  var useModal = _ref5.useModal,
    isIcon = _ref5.isIcon,
    props = _objectWithoutProperties(_ref5, _excluded);
  return useModal ? /*#__PURE__*/_jsx(FiltersBarWithModal, _objectSpread({
    isIcon: isIcon
  }, props)) : /*#__PURE__*/_jsx(FiltersBarWithPills, _objectSpread({}, props));
};
export default FiltersBarContainer;